import React from 'react';
import ModalRole from '../../views/roles/ModalRole'
import ModalUser from '../../views/users/ModalUser'
import ModalClient from '../../views/clients/ModalClient';
import ModalTemplate from '../../views/templates/ModalTemplate';
import ModalOrder from '../../views/orders/ModalOrders';
import ModalPlan from '../../views/plans/ModalPlan';
import ModalLog from '../../views/logs/ModalLog';
import ModalInbursaUsers from '../../views/inbursa/inbursausers/ModalMultiInbursaUsers';
import ModalInbursaTemplate from '../../views/inbursa/inbursatemplates/ModalInbursaTemplate';
import ModalPayMethod from '../../views/catalogs/paymethods/ModalPayMethod';
import ModalUrls from '../../views/reports/monitorUrls/ModalUrls';

const modalComponents = {
  'Role': ModalRole,
  'User': ModalUser,
  'Order': ModalOrder,
  'Client': ModalClient,
  'Template': ModalTemplate,
  'Plan': ModalPlan,
  'Log': ModalLog,
  'InbursaUsers': ModalInbursaUsers,
  'InbursaTemplate': ModalInbursaTemplate,
  'PayMethod': ModalPayMethod,
  'MonitorUrls': ModalUrls
};

export default function Modalv2({ show, handleClose, dataItem, setRenderRows }) {
  const ModalComponent = modalComponents[dataItem.nameView];

  if (!ModalComponent)
       return (<div></div>);

  return (
    <ModalComponent
      show={show}
      handleClose={handleClose}
      dataItem={dataItem}
      setRenderRows={setRenderRows}
    />
  );
}